export default __webpack_public_path__ + "static/media/objectH.4cd980cc.png";